<script>
export default {
  data() {
    return {
      list: [
        {
          title: '進階方案功能',
          popover: `包含預約管理系統、客戶＆寵物管理、員工管理、排班設定、管理帳號分權、以及預付方案管理、金流串接、分店設定、簡訊通知、優惠券功能、管理帳號30個、免費網域、報表數據、公版官網、官方Line預約`,
          reserveplan: true,
          marketingplan: true,
          intermediate: true
        },
        {
          title: '系統輔助轉型',
          popover: false,
          reserveplan: true,
          marketingplan: true,
          intermediate: true
        },
        {
          title: '專業行銷顧問團隊',
          popover: false,
          reserveplan: false,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '店門形象拍攝',
          popover: false,
          reserveplan: false,
          marketingplan: `專業拍攝4-5張`,
          intermediate: `依據需求設定拍攝數量`
        },
        {
          title: '行銷設計',
          popover: false,
          reserveplan: false,
          marketingplan: `行銷設計8-14則`,
          intermediate: `依據需求設定設計數`
        },
        {
          title: '本地商家資訊建置',
          popover: false,
          reserveplan: false,
          marketingplan: true,
          intermediate: true
        },
      ],
      // lists: [
      //   {
      //     title: '專屬網站',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '預約網頁',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     professional: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     }
      //   },
      //   {
      //     title: '商品POS',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '預約管理',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '分店',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: '升級成專業',
      //       halfYear: '升級成專業',
      //       year: '升級成專業',
      //     },
      //     professional: {
      //       month: 1,
      //       halfYear: '1+1 加購 5500元/分店',
      //       year: '1+1 加購 5500元/分店',
      //     }
      //   },
      //   {
      //     title: '客戶管理',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '美容管理 (排班)',
      //     simple: {
      //       month: '1位',
      //       halfYear: '1位',
      //       year: '1位',
      //     },
      //     normal: {
      //       month: '最多5位',
      //       halfYear: '最多5位',
      //       year: '最多5位',
      //     },
      //     professional: {
      //       month: '每一家店 8位',
      //       halfYear: '每一家店 8位',
      //       year: '每一家店 8位',
      //     }
      //   },
      //   {
      //     title: '數據分析',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '簡訊',
      //     simple: {
      //       month: 0,
      //       halfYear: 0,
      //       year: 0,
      //     },
      //     normal: {
      //       month: '100則/月',
      //       halfYear: '100則/月',
      //       year: '100則/月',
      //     },
      //     professional: {
      //       month: '300則/月',
      //       halfYear: '300則/月',
      //       year: '300則/月',
      //     }
      //   },
      //   {
      //     title: '線上預約',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: 'Line串接',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '優惠券系統',
      //     simple: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     normal: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '儲值金系統',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '套裝模組系統',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      //   {
      //     title: '金流串接',
      //     simple: {
      //       month: false,
      //       halfYear: false,
      //       year: false,
      //     },
      //     normal: {
      //       month: '開通 收費5,000',
      //       halfYear: '開通 收費5,000',
      //       year: '開通 收費5,000',
      //     },
      //     professional: {
      //       month: true,
      //       halfYear: true,
      //       year: true,
      //     }
      //   },
      // ]
    }
  }
}
</script>

<template>
  <div :class="$style.sectionCompare">
    <!-- <img src="@assets/images/home/section7-image.png" alt="" class="sectionSecondary__img"> -->
    <div class="container">
      <BaseSectionTitle 
        title="方案功能比較" 
        sub-title="Comparison" 
        class="isStyleDecoration"
      />
      <div class="d-lg-none d-flex color-text-3 mb-3" style="font-size: 0.75rem">
        <div class="align-self-center">
          <i class="fal fa-exclamation-square color-primary ls-0"></i>
            右滑查看完整內容
          <i class="icomoon icon-arrow-button"></i>
        </div>
        <div class="slide-right finger ml-auto">
          <img src="@assets/images/plan/hand-icon.svg" alt="">
        </div>
      </div>
      <div class="table-responsive-lg">
        <table class="table table-width">
          <thead class="sectionCompare__thead">
            <tr class="sectionCompare__thead--th">
              <th scope="col" class="align-middle">功能</th>
              <th scope="col" class="text-center" width="27%">
                <p>客戶管理小資方案</p>
                <p>
                  <span class="money font-josefin">$36,000</span>
                  <span class="count ml-2">/年</span>
                </p>
                <span class="round py-2 px-3">或半年繳$18,000</span>
              </th>
              <th scope="col" class="text-center" width="27%">
                <p>線上預約系統方案</p>
                <p>
                  <span class="money font-josefin">$59,600</span>
                  <span class="count ml-2">起/年</span>
                </p>
                <span class="round py-2 px-3">或半年繳$42,600起</span>
              </th>
              <th scope="col" class="text-center" width="27%">
                <p>專業店家方案</p>
                <p class="money font-josefin">$依功能制定</p>
                <span class="round py-2 px-3">適合連鎖/獨立官網店家</span>
              </th>
            </tr>
          </thead>
          <tbody class="sectionCompare__tbody">
            <tr
              v-for="(item,$index) in list"
              :key="$index"
              class="sectionCompare__tbody--td"
            >
              <td>
                {{item.title}}
                  <el-popover
                    v-if="item.popover"
                    placement="top"
                    title=""
                    width="288"
                    trigger="hover"
                    :content="item.popover"
                  >
                    <el-button slot="reference" class="el-button">
                      <i class="icomoon icon-info"></i>
                    </el-button>
                  </el-popover>
              </td>
              <td class="text-center">
                <template v-if="typeof item.reserveplan === 'boolean'">
                  <span v-if="item.reserveplan">
                    <i class="icomoon icon-check check"></i>
                  </span>
                </template>
                <template v-else>
                  <div v-html="item.reserveplan"></div>
                  <!-- {{item.reserveplan}} -->
                </template>
              </td>
              <td class="text-center">
                <template v-if="typeof item.marketingplan === 'boolean'">
                  <span v-if="item.marketingplan">
                    <i class="icomoon icon-check check"></i>
                  </span>
                </template>
                <template v-else>
                  <div v-html="item.marketingplan"></div>
                  <!-- {{item.marketingplan}} -->
                </template>
              </td>
              <td class="text-center">
                <template v-if="typeof item.intermediate === 'boolean'">
                  <span v-if="item.intermediate">
                    <i class="icomoon icon-check check"></i>
                  </span>
                </template>
                <template v-else>
                  <div v-html="item.intermediate"></div>
                  <!-- {{item.intermediate}} -->
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionCompare {
  position: relative;
  &:before {
    
    content: '';
    position: absolute;
    // bottom: 5%;
    top: 26%;
    left: 0;
    background-image: url('@assets/images/basicplan/section6-bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 38%;
    padding-bottom: 58%;
    @include max-xl {
      display: none;
    }
  }
  @include max-lg {
    margin-top: 55px;
  }
  :global {
    .baseSectionTitle {
      max-width: 100%;
    }
    .sectionCompare {
      &__thead {
        background: #f7f9fa;
        border: 6px;
        &--th {
          color: $color-text-1;
          font-size: 21px;
          @include max-md {
            font-size: 18px;
          }
          @include max-sm {
            font-size: 15px;
          }
          p {
            margin: 0;
          }
          .money {
            font-size: 28px;
            @include max-md {
              font-size: 24px;
            }
            @include max-sm {
              font-size: 21px;
            }
          }
          .count {
            font-size: 16px;
            padding-left: 5px;
            @include max-md {
              font-size: 14px;
            }
            @include max-sm {
              font-size: 12px;
            }
          }
          .round{
            background: #989bac;
            font-size: 16px;
            border-radius: 10px;
            width: auto;
            color: #fff;
          }
          th {
            border-top: 0;
            border-bottom: 0;
            padding-top: 30px;
            padding-bottom: 30px;
            background: #f7f9fa;
          }
        }
      }
      &__tbody {
        &--td {
          td {
            border-top: 0;
            border-bottom: 1px solid $color-line;
            padding-top: 30px;
            padding-bottom: 30px;
            color: $color-text-2;
            background: #fff;
            vertical-align: middle;
            @include max-md {
              font-size: 14px;
            }
            @include max-sm {
              font-size: 12px;
            }
          }
          .check {
            color: $color-primary;
          }
          .el-button {
            border: 0;
            padding: 0;
            color: $color-text-2;
            &:hover {
              background: transparent;
              color: $color-text-2;
            }
          }
        }
      }
      &__mobile {
        // &__icon {
        //   display: inline-block;
        //   width: 11px;
        //   height: 13px;
        //   line-height: 13px;
        //   text-align: center;
        //   border: 1px solid $color-primary;
        //   color: $color-primary;
          
        // }
      }
    }
    .table-width {
      min-width: 900px;
      position: relative;
      td:first-child, th:first-child {
        position:sticky;
        left:0;
        z-index:3;
      }
    }
    .finger {
      margin-right: 20px;
      animation-name: slideRight;
      animation-duration: 1.5s;
      animation-timing-function: linear;
      animation-iteration-count:infinite;
      animation-direction: alternate;
      // transform: translateX(0);
      img {
        max-width: 25px;
      }
    }

  }
}
</style>